var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91406 9.64062L4.69531 8.39062C4.1875 8.27344 3.875 7.80469 3.875 7.29688C3.875 6.67188 4.38281 6.125 5.00781 6.125H7.58594C8.09375 6.125 8.5625 6.28125 8.95312 6.55469C9.1875 6.71094 9.5 6.67188 9.69531 6.47656L11.0625 5.14844C11.3359 4.875 11.2969 4.44531 10.9844 4.17188C10.0469 3.42969 8.83594 3.03906 7.625 3V1.125C7.625 0.8125 7.3125 0.5 7 0.5H5.75C5.39844 0.5 5.125 0.8125 5.125 1.125V3H5.00781C2.50781 3 0.515625 5.14844 0.75 7.6875C0.90625 9.48438 2.27344 10.9688 4.03125 11.4766L8.01562 12.6484C8.52344 12.7656 8.875 13.2344 8.875 13.7422C8.875 14.3672 8.32812 14.875 7.70312 14.875H5.125C4.65625 14.875 4.1875 14.7578 3.79688 14.4844C3.52344 14.3281 3.21094 14.3672 3.01562 14.5625L1.64844 15.8906C1.375 16.1641 1.41406 16.5938 1.72656 16.8281C2.70312 17.6094 3.875 18 5.125 18V19.875C5.125 20.2266 5.39844 20.5 5.75 20.5H7C7.3125 20.5 7.625 20.2266 7.625 19.875V18C9.42188 17.9609 11.1406 16.9062 11.7266 15.1875C12.5859 12.7656 11.1797 10.3047 8.91406 9.64062Z",
    fill: "#48AE34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.37279990.svg";
export { ForwardRef as ReactComponent };